import app from './app';
import translation from './translation';
import news from './news';
import game from './game';
import personality  from './personality';
import book from './book';
import user from './user';

export default { app, translation, news, game, personality, book, user };
